import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import styles from './ItemHasRecipe.css';

class ItemHasRecipe extends React.Component {
  render() {
    const { onClickIngredient, hasRecipe } = this.props;
    return (
      hasRecipe && (
        <div className="row">
          <div className="col-md-12">
            <div className={styles['content-wrapper']}>
              <img
                src={require('assets/images/raw-ingredient-icon.png')}
                alt="item has recipe icon"
                className={styles['recipe-icon']}
              />
              <p className={styles['text-has-recipe']}>This item has recipe</p>
              <p className={styles['text-manage']}>
                Please go to <Link onClick={onClickIngredient}>ingredient</Link>{' '}
                to manage your inventory
              </p>
            </div>
          </div>
        </div>
      )
    );
  }
}

ItemHasRecipe.propTypes = {
  hasRecipe: PropTypes.bool,
  onClickIngredient: PropTypes.func,
};

export default ItemHasRecipe;
